<template>
  <div id="deviceDetail">
    <van-tabs v-model="active" class="tabs">
      <van-tab title="基本信息">
        <van-cell title="厂商" :value="deviceDetail.vendorName" />
        <!-- <van-cell title="厂商编码" :value="deviceDetail.vendorCode" /> -->
        <van-cell
          title="设备类型"
          :value="deviceDetail.type ? deviceType[+deviceDetail.type - 1] : '-'"
        />
        <van-cell
          title="设备状态"
          :value="deviceStatus[deviceDetail.status - 1]"
        />
         <van-cell  v-if="deviceDetail.vendorCode == 'IM'"
          title="设备电量"
          :value="(deviceDetail.power>0?deviceDetail.power + '%' + '(锂电池)':0+'%' + '(锂电池)') + ' -- ' + (deviceDetail.alkPower>0?deviceDetail.alkPower + '%' + '(干电池)':0+'%' + '(干电池)')"
        />
        <van-cell v-else
          title="设备电量"
          :value="deviceDetail.power>0?deviceDetail.power+'%':'0%'"
        />
        <van-cell
          title="在线状态"
          :value="onlineList[deviceDetail.online-1]"
        />
        <van-cell
          title="项目/小区名称"
          :value="deviceDetail.communityName ? deviceDetail.communityName : '-'"
        />
        <van-cell
          title="房源编码"
          :value="deviceDetail.houseNumber ? deviceDetail.houseNumber : '-'"
        />
        <van-cell
          title="房源地址"
          :value="deviceDetail.address ? deviceDetail.address : '-'"
        />
        <van-cell
          title="房间号"
          :value="deviceDetail.roomNo ? deviceDetail.roomNo : '-'"
        />
        <van-cell title="序列号" :value="deviceDetail.sn || '-'" />
        <van-cell title="uuid" :value="deviceDetail.uuid || '-'" />
        <van-cell
          title="最后一次在线更新时间"
          :value="deviceDetail.onlineTime || '-'"
        />
         <van-cell
          title="最后一次离线时间"
          :value="deviceDetail.lastOfflineTime || '-'"
        />
        <van-cell v-if="deviceDetail.type != 1"
          title="上次抄表度数"
          :value="
            deviceDetail.lastReportAmount !=null
              ? deviceDetail.lastReportAmount
              : '-'
          "
        />
        <van-cell v-if="deviceDetail.type != 1"
          title="上次抄表时间"
          :value="
            deviceDetail.lastReportTime ? deviceDetail.lastReportTime : '-'
          "
        />
        <van-cell title="描述" :value="deviceDetail.description" />
      </van-tab>
      <van-tab v-if="deviceDetail.type == 1" title="操作记录">
        <div class="body">
          <table
            v-if="
              deviceDetail.operationList && deviceDetail.operationList.length
            "
          >
            <thead>
              <tr>
                <th>合约编码</th>
                <th>服务Id</th>
                <th>操作类型</th>
                <th>状态</th>
                <th>密码操作</th>
                <th>是否有效</th>
                <th>密码ID</th>
                   <th>密码</th>
                <th>密码有效开始时间</th>
                <th>密码有效结束时间</th>
                 <th>备注</th>
                <th>创建时间</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(tr, trx) in deviceDetail.operationList || []"
                :key="trx"
              >
                <td class="min2">
                  {{ tr.contractNumber ? tr.contractNumber : "-" }}
                </td>
                <td class="min2">{{ tr.serviceId ? tr.serviceId : "-" }}</td>
                <td class="min2">
                  {{ tr.type ? operationTypeList[tr.type - 1] : "-" }}
                </td>
                <td class="min2">
                  {{ tr.result ? operationResult[tr.result - 1] : "-" }}
                </td>
                <td class="min2">{{ tr.op ? opListStatus[tr.op -1] : "-" }}</td>
                <td class="min2">
                     <div v-if="tr.valid == 1">
                   有效
                  </div>
                  <div v-else-if="tr.valid == 0">
                   无效
                  </div>
                   <div v-else-if="tr.valid == null">
                   -
                  </div>

                </td>

                <td class="min2">{{ tr.passwordId ? tr.passwordId : "-" }}</td>
                   <td class="min2">{{ tr.password ? tr.password : "-" }}</td>
                <td class="min2">{{ tr.startTime ? tr.startTime : "-" }}</td>
                <td class="min2">{{ tr.endTime ? tr.endTime : "-" }}</td>
                <td class="min2">{{ tr.remark ? tr.remark : "-" }}</td>
                  <td class="min2">{{ tr.createDate ? tr.createDate : "-" }}</td>
              </tr>
            </tbody>
          </table>
          <van-empty v-else description="暂无数据" />
        </div>
      </van-tab>
      <van-tab title="事件列表">
  <div class="body">
          <table
            v-if="
              deviceDetail.eventList && deviceDetail.eventList.length
            "
          >
            <thead>
              <tr>
                <th>类型名称</th>
                <th>发生时间</th>
                <th>创建时间</th>
                <th>云丁返回数据</th>
            
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(tr, trx) in deviceDetail.eventList || []"
                :key="trx"
              >
                <td class="min2">
                  {{ tr.typeName ? tr.typeName : "-" }}
                </td>
                <td class="min2">{{ tr.time ? tr.time : "-" }}</td>
                <td class="min2">{{ tr.createDate ? tr.createDate : "-" }}</td>
                <td class="min2">{{ tr.detail ? tr.detail : "-" }}</td>
                 

              </tr>
            </tbody>
          </table>
          <van-empty v-else description="暂无数据" />
        </div>
      </van-tab>
      <van-tab
        v-if="deviceDetail.type > 1 && deviceDetail.type < 5"
        title="抄表记录"
      >
        <div class="body">
          <table
            v-if="deviceDetail.historyList && deviceDetail.historyList.length"
          >
            <thead>
              <tr>
                <th>读取时间</th>
                <th>上报时间</th>
                <th>上报度数</th>
                <th>是否消费</th>
                <th>生成类型</th>
                <th>图片地址</th>
                <th>创建时间</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(tr, trx) in deviceDetail.historyList || []"
                :key="trx"
              >
                <td class="min2">{{ tr.createDate ? tr.createDate : "-" }}</td>
                <td class="min2">{{ tr.reportTime ? tr.reportTime : "-" }}</td>

                <td class="min2">
                  {{ tr.reportAmount ? tr.reportAmount : "-" }}
                </td>
                <td class="min2">{{ tr.consumeFlag ? "是" : "否" }}</td>
                <td class="min2">
                  {{ tr.generationType == 1 ? "系统" : "手动" }}
                </td>
                <td class="min2">
                  <!-- {{ tr.imgUrl ? tr.imgUrl : "-" }} -->
                  <div  @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [tr.imgUrl];
                " v-if="tr.imgUrl" class="img">查看</div>
                  <div v-else>-</div>
                </td>
                  <td class="min2">{{ tr.createDate ? tr.createDate : "-" }}</td>
              </tr>
            </tbody>
          </table>
          <van-empty v-else description="暂无数据" />
        </div>
      </van-tab>

      <van-tab
        v-if="deviceDetail.type > 1 && deviceDetail.type < 5"
        title="消费记录"
      >
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" offset="100" @load="getConsumeList">
            <div class="body">
                <div class="card" v-for="(item,index) in consumeList" :key="index">
                  
                    <p>
                        <span class="title1">
                            <span>{{item.address}}</span>
                            | {{item.roomNo == '公区'? '公区' : item.roomNo}}
                        </span>
                    </p>
                    <!-- <p>
                        <span>户型：{{item.chamberNum||'-'}}室{{item.hallNum||'-'}}厅{{item.toiletNumber||'-'}}卫 {{item.totalAcreage}} ㎡</span>
                        <span :class="success-color">{{roomStatusList[item.status-1]}} | {{statusReserveList[item.statusReserve-1]}}</span>
                    </p> -->
                    <p>
                        <span>
                           {{item.deviceTypeDesc}} | 本次用量：{{item.currentAmount}}
                        </span>
                        <span class="success-color">{{item.amountYuan}}元</span>
                    </p>
                  
                       <p>抄表开始时间：{{item.startTime}}</p>
                          <p>抄表结束时间：{{item.endTime}}</p>
                             <p>抄表开始度数：{{item.startAmount}}  抄表结束度数：{{item.endAmount}}</p>
                                <p>创建时间：{{item.createDate}}</p>
                        
                </div>
            </div>
        </van-list>
      </van-tab>
    </van-tabs>
    <div class="btn" v-if="!$route.query.type" style="overflow-y: hidden">
      <van-button
        type="primary"
        v-if="$store.state.buttonAuth.indexOf('refreshDevice') > -1"
        @click="refresh()"
        >刷新</van-button
      >
      <van-button
        type="primary"
        v-if="
          deviceDetail.type != 5 &&
          deviceDetail.type != 6 &&
          deviceDetail.status != 3
        "
        @click="change()"
        >换绑</van-button
      >
      <van-button
        type="primary"
        v-if="
        deviceDetail.type != 1 &&
          deviceDetail.type != 5 &&
          deviceDetail.type != 6 &&
          deviceDetail.status != 3
        "
        @click="read()"
        >抄表</van-button
      >
    </div>
    <van-dialog
      v-model="dialogChangeDevice"
      title="设备换绑"
      show-cancel-button
      :before-close="saveChangeDevice"
      class="sendLock"
    >
      <van-form ref="changeDeviceForm" input-align="right">
        <van-field
          readonly
          required
          name="device"
          :value="changeVal"
          label="设备"
          placeholder="点击搜索设备>"
          @click="
            (item) => {
              showChangeDevice = true;

              searchChangeDevice = '';
            }
          "
          :rules="[{ required: true, message: '请选择设备' }]"
        />
      </van-form>
    </van-dialog>
    <!-- 设备抄表 -->
    <van-dialog
      v-model="dialogReadDevice"
      title="设备抄表"
      show-cancel-button
      :before-close="saveReadDevice"
      class="sendLock"
    >
      <van-form ref="readDeviceForm" input-align="right">
        <van-field
          name="抄表模式"
          label="抄表模式"
          required
          :rules="[{ required: true, message: '请选择抄表模式' }]"
        >
          <template #input v-if="active === 0">
            <van-radio-group
              v-model="readQuery.readingType"
              direction="horizontal"
            >
              <!-- <van-radio :name="1" 
                >在线抄表</van-radio
              > -->

              <van-radio :name="2">离线抄表</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          required
          v-model="readQuery.reportAmount"
          label="上报度数"
          placeholder="请填写上报度数"
          :rules="[{ required: true, message: '请填写上报度数' },{
               validator: (item) => {
                return item >0;
              },

              message: '上报度数必须大于0',
            }, {
              validator: validateReportAmount,

               message: `${deviceDetail.type ==2 ||deviceDetail.type ==4 ? '上报度数最多保留两位小数':'上报度数必须大于0且为正整数'}`,
            },]"
        />
       <div class="field van-cell--required">图片地址</div>

        <div class="body">
          <div class="picCard textBorder">
            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  readUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.readDeviceForm.resetValidation('readUrl');
                }
              "
              v-model="readUrl"
              :max-count="1"
            />

             <div class="text">
              <van-field
           
                name="readUrl"
                disabled
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(readUrl.length) || !imgUp;
                    },

                    message: '请上传抄表图片',
                  },
                ]"
              />
            </div>
          </div>
        </div>
      </van-form>
    </van-dialog>
    <transition name="van-slide-right">
      <div v-if="showChangeDevice" class="search">
        <form action="/">
          <van-search
            v-model="searchChangeDevice"
            shape="round"
            show-action
            placeholder="请输入设备sn/uuid搜索"
            @input="onSearchDevice"
            @search="onSearchDevice"
            @cancel="onCancel"
          />
        </form>

        <van-cell
          v-for="device in changeDeviceList"
          :key="device.id"
          :title="
            device.vendorName +
            '-' +
            deviceType[device.type - 1] +
            '-' +
            device.sn
          "
          icon="wap-home-o"
          @click="changeDevice(device)"
        ></van-cell>

        <van-loading v-if="searchLoad" size="24" />

        <div v-else-if="searchChangeDevice && !changeDeviceList.length">
          暂无数据
        </div>
      </div>
    </transition>
       <!-- 图片预览 -->
    <van-image-preview
      v-model="imgShow"
      :startPosition="imgIndex"
      :images="images"
    ></van-image-preview>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  validPhone,
  validEmail,
  validIdNo,
  validNum,
  validNum0Decimal2,
  validNum0Decimal1,
  validNum100,
} from "@/utils/validate";
import {
  requsetDeviceDetail,
  requestDeviceTypeList,
  requestDeviceSearchList,
  requestChangeDeviceSave,
    requestQiniuToken, //七牛token
    requestDeviceReading,
    requestconsumeRecordList,
    requestDeviceRefresh
} from "@/api";

import { imgUp } from "@/common/js/constant.js";
import request from "@/utils/request";
import { compress, compressAccurately } from "image-conversion";
import { accSub } from "@/utils";
export default {
  name: "deviceDetail",

  data() {
    return {
      loading: false,
            finished: false,
           imgUp: imgUp,

      active: 0,
      deviceDetail: {},
      deviceTypeList: [
        {
          code: "",
          desc: "",
          value: "",
        },
      ],
      dialogChangeDevice: false,
      newId: "",
      searchChangeDevice: "",
      changeDeviceList: [],
      showChangeDevice: false,
      searchLoad: false,
      changeVal: "",
      dialogReadDevice: false,
      readQuery: {
        readingType: 2,
        deviceId: "",
        reportAmount: "",
        imgUrl: "",
      },
      consumeList:[],
      readUrl:[],
       qiniuData: {
        key: "",

        token: "",
      },
      listQuery: {
        deviceId: "",
        pageNumber: 1,
        pageSize: 20,
      },
         imgShow: false,
      imgIndex: 0,
      images: [],
    };
  },
  computed: {
    ...mapState([
      "deviceStatus",
      "deviceType",
      "operationTypeList",
      "operationResult",
      "opListStatus",
            "upload_qiniu_addr",
            "onlineList"
    ]),
  },
     activated() {
        this.listQuery.pageNumber = 1;
        this.finished = false;
        this.list = [];
        this.getDetail();
        // this.getConsumeList()
    },
  created() {
    this.getDetail();
  },
  mounted() {
    this.getQiniuToken();
  },
  methods: {
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requsetDeviceDetail(this.$route.query.id)
        .then((res) => {
          this.deviceDetail = res.data;
          this.listQuery.deviceId = this.deviceDetail.id;
          this.getConsumeList(this.listQuery)
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
     getConsumeList() {
      this.loading = true;
      requestconsumeRecordList(this.listQuery)
        .then((res) => {
          if (res) {
             if (this.finished) return;
                 
                    this.consumeList = [...this.consumeList, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
          }
            // this.consumeList = res.data.records;
            // this.total = res.data.total;
            // this.$nextTick(() => {
            //   this.$refs.consumeListTable.doLayout();
            // });
          }
        })
        .catch((err) => {
         this.loading = false;
                    this.finished = true;
        });
    },
    change() {
      this.dialogChangeDevice = true;
    },
    saveChangeDevice(action, done) {
      if (action === "confirm") {
        this.$refs.changeDeviceForm
          .validate()
          .then((valid) => {
            let param = {
              id: this.deviceDetail.id,
              newId: this.newId,
            };
            requestChangeDeviceSave(param)
              .then((res) => {
                if (res) {
                  this.$toast.success({
                    message: "换绑成功",
                    onOpened: () => {
                      this.$route.query.id = this.newId;
                      this.getDetail();
                      this.dialogChangeDevice = false;
                      this.changeVal = "";
                      this.changeDeviceList = [];
                      done();
                    },
                  });
                }
              })
              .catch((err) => {
                this.$toast.fail("换绑失败");
                done(false);
                console.log(err);
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
        this.reset();
      }
    },
    changeDevice(val) {
      console.log(val);
      this.newId = val.id;
      this.changeVal =
        val.vendorName + "-" + this.deviceType[val.type - 1] + "-" + val.sn;
      this.showChangeDevice = false;
    },
    onSearchDevice() {
      if (!this.searchChangeDevice) return;

      this.searchLoad = true;

      this.changeDeviceList = [];

      requestDeviceSearchList(
        this.deviceDetail.type,
        this.searchChangeDevice
      ).then((res) => {
        this.searchLoad = false;

        this.changeDeviceList = res.data || [];
      });
    },
    read() {
      this.dialogReadDevice = true;
    },
    saveReadDevice(action, done) {
      if (action === "confirm") {
        this.$refs.readDeviceForm
          .validate()
          .then((valid) => {
            this.readQuery.deviceId = this.deviceDetail.id;
            this.readQuery.imgUrl  = this.readUrl[0].url
          console.log(this.readQuery)
            requestDeviceReading(this.readQuery)
              .then((res) => {
                if (res) {
                  this.$toast.success({
                    message: "抄表成功",
                    onOpened: () => {
                      
                      this.getDetail();
                      this.dialogReadDevice = false;
                      this.readUrl = [];
                      done();
                    },
                  });
                }
              })
              .catch((err) => {
                this.$toast.fail("抄表失败");
                done(false);
                console.log(err);
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
        this.reset();
      }
    },
    reset() {
      this.changeDeviceList = [];
      this.dialogChangeDevice = false;
       this.dialogReadDevice = false;
      this.readUrl = [];
      this.readQuery = {
        deviceId :"",
        readingType:2,
        reportAmount:"",
        imgUrl:""
      }
      this.changeVal = "";
      this.newId = "";
    },
    onCancel() {
      this.showChangeDevice = false;
    },
        //获取七牛token

    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })

        .catch((err) => {
          console.log(err);
        });
    },
     //图片上传前校验，压缩
    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt8M = file.size / 1024 / 1024 < 8;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");
        return false;
      }
      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");
        return false;
      }
      this.qiniuData.key = Date.now() + file.name;
      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();
          data.append("token", this.qiniuData.token);
          data.append("key", this.qiniuData.key);
          data.append("file", fileMin);
          request({
            url: this.$store.state.qiniuUpload,
            method: "post",
            processData: false,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: data,
          })
            .then((res) => {
              let newFile = fileMin;
              newFile.key = res.key;
              resolve(newFile);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
      });
    },
    refresh() {
      console.log(123);
      requestDeviceRefresh(this.deviceDetail.uuid).then(res=>{
        console.log(res)
          this.getDetail()
      }).catch(err=>{
        
      })
     
    },
    validateReportAmount(){
         if(this.deviceDetail.type == 3){
            return validNum(this.readQuery.reportAmount)
        }else{
            return this.validNum0Decimal2(this.readQuery.reportAmount)
        }
    },
      validNum(val) {
      console.log(val, validNum(val));
      return validNum(val);
    },
    validNum0Decimal1(val){
      return validNum0Decimal1(val)
    },
      //正数或0，最多保留两位小数
    validNum0Decimal2(val) {
      return validNum0Decimal2(val);
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#deviceDetail {
  .colorC {
    color: $colorC;
  }
  .titlee {
    padding: 0.2rem 0;
    background-color: #fff;
    font-size: 0.3rem;
  }
  .content {
    background-color: #fff;
    display: flex;
    // border-radius: 0.2rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    &.nowarp {
      flex-wrap: nowrap;
    }
    .inlineB {
      flex: 1;
      padding: 0.2rem 0;
      width: 33.3%;
      min-width: 33.3%;
      max-width: 33.3%;
      p.l {
        line-height: 0.7rem;
        height: 0.7rem;
      }
    }
  }
  .tabs {
    /deep/.van-tabs__wrap {
      margin: 0 0 0.2rem 0;
    }
    /deep/.van-tabs__content {
      height: calc(100vh - 3.6rem);
      overflow: scroll;
    }
    /deep/ .lock .van-tabs__content {
      height: calc(100vh - 6rem);
      overflow: scroll;
    }
    /deep/.van-tabs__nav--card {
      border: 0.02667rem solid #fd7e2d;
    }
    /deep/.van-tabs__nav--card .van-tab.van-tab--active {
      background-color: #fd7e2d;
      color: #fff;
    }
    /deep/.van-tabs__nav--card .van-tab {
      color: #333;
      border-right: 0.02667rem solid #fd7e2d;
    }
    /deep/.van-tabs__nav--card .van-tab:last-child {
      border-right: none;
    }
    .van-steps {
      text-align: left;
      padding-left: 2rem;
      /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
          padding-top: 0.2rem;
        }
      }
    }
    .body {
      width: 100%;
      overflow-x: auto;
      table {
        min-width: 100%;
        width: auto;
        text-align: center;
        border-left: 1px solid #ebeef5;
        border-top: 1px solid #ebeef5;
        tr {
          td,
          th {
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
          }
          td {
            background: #fff;
          }
        }
        tr > th:first-child,
        tr > td:first-child {
          position: sticky;
          position: -webkit-sticky;
          left: 0;
          z-index: 10;
          text-align: left;
        }
        thead {
          tr {
            background-color: #f3f9ff;
            th {
              // position: sticky;
              // position: -webkit-sticky;
              // top: 0;
              background-color: #f3f9ff;
            }
          }
        }
        .active {
          background: #e6f2fd;
          td {
            background: #e6f2fd;
          }
        }
      }
    }
    .body {
      // padding-top: 0.001rem;
      font-size: 0.35rem;
      // margin-top: 0.3rem;
      .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
          text-align: left;
          display: flex;
          justify-content: space-between;
          padding: 0 0.4rem;
          line-height: 0.8rem;
          // height: 0.8rem;
          .titlec {
            font-size: 0.35rem;
            font-weight: 600;
            color: #000;
            // span {
            //     max-width: 4.5rem;
            //     vertical-align: top;
            //     overflow: hidden;
            //     display: inline-block;
            //     height: auto;
            //     text-overflow: ellipsis;
            // }
            // .ellipsis {
            //     white-space: nowrap;
            // }
          }
          .big {
            font-size: 0.5rem;
          }
        }
      }
      > .card:first-child {
        margin-top: 0;
      }
      .theme-color {
        color: $theme-color;
      }
    }
    .title {
      text-align: left;
      padding: 0.3rem 0.2rem;
      font-weight: 600;
      font-size: 0.37rem;
    }
    .imgBody {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      background-color: #fff;
      padding: 0 0.2rem 0.2rem 0.2rem;
      border-radius: 0.2rem;
      .imgCard {
        padding: 0.2rem;
        .text {
          line-height: 0.8rem;
        }
      }
    }
    .lockList {
      // padding-top: 0.001rem;
      font-size: 0.35rem;
      // margin-top: 0.3rem;
      .card {
        background: #fff;
        margin-bottom: 0.3rem;
        // border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
          text-align: left;
          display: flex;
          justify-content: space-between;
          padding: 0 0.4rem;
          line-height: 0.8rem;
          > span {
            height: 0.8rem;
          }
          .lockBody-title {
            font-size: 0.35rem;
            font-weight: 600;
            height: auto;
            color: #000;
            // span {
            //     max-width: 4.5rem;
            //     vertical-align: top;
            //     overflow: hidden;
            //     display: inline-block;
            //     height: auto;
            //     text-overflow: ellipsis;
            // }
            // .ellipsis {
            //     white-space: nowrap;
            // }
          }
          .big {
            font-size: 0.4rem;
          }
        }
      }

      > .card:first-child {
        margin-top: 0;
      }
      .theme-color {
        color: $theme-color;
      }
    }
  }
  .btn {
    width: 100%;
    // z-index: 8848;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
      margin-left: -1px;
      border: none;
      border-radius: 0;
      flex: 1;
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
    a {
      color: #fff;
    }
  }
  /deep/.van-dialog__header {
    margin-bottom: 0.4rem;
  }
 
}
 .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
            text-align: left;
            display: flex;
            justify-content: space-between;
            padding: 0 0.4rem;
            line-height: 0.8rem;
            span {
                height: 0.8rem;
            }
            .title1 {
                font-size: 0.35rem;
                font-weight: 600;
                height: auto;
                color: #000;
                // span {
                //     max-width: 4.5rem;
                //     vertical-align: top;
                //     overflow: hidden;
                //     display: inline-block;
                //     height: auto;
                //     text-overflow: ellipsis;
                // }
                // .ellipsis {
                //     white-space: nowrap;
                // }
            }
            .big {
                font-size: 0.4rem;
            }
        }
    }
    > .card:first-child {
        margin-top: 0;
    }
    .theme-color {
        color: $theme-color;
    }
    .success-color {
        color: $success-color;
    }
    .fail-color {
        color: $fail-color;
    }
    .color9 {
        color: $color9;
    }
.success {
  color: $success-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.fail {
  color: $fail-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.field {
  padding: 0.26667rem 0.42667rem;

  background: #fff;

  font-size: 0.3rem;

  line-height: 0.64rem;

  color: #323232;

  text-align: left;

  border-top: 1px solid #ebedf0;

  border-bottom: 1px solid #ebedf0;

  .button-mini {
    width: 0.5rem;

    height: 0.5rem;

    line-height: 0.5rem;

    display: inline-block;

    text-align: center;

    border: 1px solid #a2a2a2;

    border-radius: 0.1rem;

    vertical-align: middle;
  }
}
.search {
  width: 100%;

  height: 100%;

  position: fixed;

  top: 0;
  left: 0;
  background-color: #fff;

  z-index: 9999;

  // overflow: scroll;

  .van-search {
    /deep/i {
      line-height: 0.84rem;
    }

    /deep/input {
      border: none;
    }
  }
}
.form {
  background-color: #fff;

  text-align: left;

  /deep/.van-field__error-message {
    text-align: center;
  }

  .field {
    position: relative;
  }

  .body {
    padding: 0.1rem;

    .van-uploader {
      // margin: 0.2rem;

      /deep/.van-uploader__preview-image {
        border: 1px solid #ebedf0;
      }
    }

    .picCard {
      display: inline-block;

      margin: 0.2rem;

      width: 2.2rem;

      .text {
        text-align: center;

        .van-field {
          padding: 0;

          /deep/input {
            text-align: center;
          }
        }
      }

      .textBorder {
        /deep/.van-field__body {
          border: 1px solid $border-color;

          border-radius: 0.1rem;

          overflow: hidden;
        }
      }
    }
  }

  .body1 {
    padding: 0.3rem;
  }
}
.deviceList {
  padding: 0 20px 20px 20px;
  display: flex;
  flex-wrap: wrap;
  .device {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    .iconfont {
      margin: 20px 0 10px 0;
      font-size: 64px;
      &.active {
        color: #cccccc;
      }
    }
    &.active {
      cursor: pointer;
    }
    p {
      font-size: 12px;
      color: #05bac5;
      margin-bottom: 15px;
      &.active {
        color: #cccccc;
      }
    }
    h5 {
      color: #05bac5;
      &.active {
        color: #cccccc;
      }
    }
  }
  
}
    .picCard {
      display: flex;
      flex-direction: column ;
      justify-content: center;
          align-items: center;

      width: 100%;

      .text {
        text-align: center;

        .van-field {
          padding: 0;

          /deep/input {
            text-align: center;
          }
        }
      }
      .van-uploader{
        margin: 0.2rem;
        width: 2.4rem;
      }
      /deep/.van-field__body{
        display: none!important;;
      }
      .textBorder {
        /deep/.van-field__body {
          border: 1px solid $border-color;

          border-radius: 0.1rem;

          overflow: hidden;
        }
      }
    }
    .img{
      color:#fd7e2d
    }
</style>
